import { render, staticRenderFns } from "./NavigationLegacy.vue?vue&type=template&id=5bfe8c78&scoped=true&"
import script from "./NavigationLegacy.vue?vue&type=script&lang=js&"
export * from "./NavigationLegacy.vue?vue&type=script&lang=js&"
import style0 from "./NavigationLegacy.vue?vue&type=style&index=0&id=5bfe8c78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfe8c78",
  null
  
)

export default component.exports